export class Dispersion {
    id?: string;
    idInvoice: string;
    noInvoice: number;
    dateCreated: number;
    dateExecuted?: number;
    dateScheduled: number;
    companyName: string;
    companyId: string;
    dispersionTypeId: number;
    dispersionTypeName: string;
    programName: string;
    programId: string;
    dispersionAmount: number;
    fees?: number;
    tax?: number;
    granTotal: number;
    status?: number; // 1 = Pending, 2 = Cleared, 3 = Completed, 4 = Error, 5 = Canceled ,6= proceso;
    notes?: {
        date: number,
        note: string,
        user: string
    }[];
    recurrance?: {
        name: string,
        id: number
    };
    beneficiaries?: {
        employeeId: string;
        employeeName: string;
        employeeLastName: string;
        employeeSecondLastName: string;
        amount: number;
        status: number;
        transactionId: string;
        transactionDate: number;
        transactionSchedule: string;
    }[];
    isDispersionPartial?;
    dispersionPartialId?;


    constructor(formData?: any) {
        let data: any = !formData ? {} : formData;
        this.id = data.id || null;
        this.idInvoice = data.idInvoice || null;
        this.noInvoice = data.noInvoice || null;
        this.dateCreated = data.dateCreated || null;
        this.dateExecuted = data.dateExecuted || null;
        this.dateScheduled = data.dateScheduled || null;
        this.companyName = data.companyName || null;
        this.companyId = data.companyId || null;
        this.dispersionTypeId = data.dispersionTypeId || null;
        this.dispersionTypeName = data.dispersionTypeName || null;
        this.programName = data.programName || null;
        this.programId = data.programId || null;
        this.dispersionAmount = data.dispersionAmount || 0;
        this.fees = data.fees || null;
        this.tax = data.tax || null;
        this.granTotal = data.granTotal || null;
        this.status = data.status || 1;
        this.notes = data.notes || null;
        this.beneficiaries = data.beneficiaries || [];
        this.recurrance = data.recurrance || {
            name: null,
            id: null
        };
    }
}
